import React from 'react'
import { Alert } from '@mui/material'
import AppModal from '../common/AppModal'
import InitiateWhatsappForm from '../../forms/InitiateWhatsappForm'

interface InitiateWhatsappModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const InitiateWhatsappModal: React.FC<InitiateWhatsappModalProps> = ({
  open,
  onClose,
  loading,
  error
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Initiate WhatsApp Template"
      width="sm"
      loading={loading}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <InitiateWhatsappForm loading={loading} />
    </AppModal>
  )
}

export default InitiateWhatsappModal
